import CustomLabel from "./CustomLabel";
import CustomInfos from "./CustomInfos";
import CustomClient from "./CustomClient";
import LoadingInfos from "./LoadingInfos";
export { CustomInfos, CustomLabel, CustomClient, LoadingInfos };
